var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#6f29a3",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24 2c3.3137 0 6 2.6863 6 6v16c0 3.3137-2.6863 6-6 6h-16c-3.3137 0-6-2.6863-6-6v-16c0-3.3137 2.6863-6 6-6h16zm-8.2322 5.9749c-0.5523 0-1 0.44772-1 1l6e-4 10.242-3.2433-3.2422c-0.3905-0.3906-1.0237-0.3906-1.4142 0-0.39051 0.3905-0.39051 1.0237 0 1.4142l4.9498 4.9497c0.3905 0.3906 1.0237 0.3906 1.4142 0l4.9497-4.9497c0.3905-0.3905 0.3905-1.0237 0-1.4142-0.3905-0.3906-1.0237-0.3906-1.4142 0l-3.2423 3.2437-3e-4 -10.244c0-0.55228-0.4477-1-1-1z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon_download.8bbe4d669e8167aaf8ec217198001782.svg";
export { ForwardRef as ReactComponent };